import { inject, Injectable } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';
import { ListService, TrackByService } from '@abp/ng.core';

import { finalize, tap } from 'rxjs/operators';

import type { WhatsAppContactDto } from '../../../proxy/whats-app-contacts/models';
import { WhatsAppContactService } from '../../../proxy/whats-app-contacts/whats-app-contact.service';
import { Confirmation, ConfirmationService } from '@abp/ng.theme.shared';

@Injectable()
export  class WhatsAppContactDetailViewService {
  protected readonly fb = inject(FormBuilder);
  protected readonly track = inject(TrackByService);

  public readonly proxyService = inject(WhatsAppContactService);
  public readonly list = inject(ListService);
  protected readonly confirmationService = inject(ConfirmationService);


  isBusy = false;
  isVisible = false;
  selected = {} as any;
  form: FormGroup | undefined;

  private readonly options: Partial<Confirmation.Options> = {
    hideCancelBtn: true,
    hideYesBtn: false,
    dismissible: true,
    yesText: "Fechar",
  };

  protected whatsappValidator() {
    return (control: AbstractControl) => {
      const pattern = /^\+55\d{10,11}$/;
      const isValid = !control.value || pattern.test(control.value);

      return isValid ? null : {
        numberFormat: 'O número deve começar com +55 seguido de 10 ou 11 dígitos.'
      };
    };
  }

  protected createRequest() {
    const formValues = {
      ...this.form.value,
    };

    if (this.selected) {
      return this.proxyService.update(this.selected.id, {
        ...formValues,
        concurrencyStamp: this.selected.concurrencyStamp,
      });
    }

    return this.proxyService.create(formValues);
  }

  buildForm() {
    const { contato1, contato2, contato3, contato4, contato5 } = this.selected || {};

    this.form = this.fb.group({
      contato1: [contato1 ?? null, [this.whatsappValidator()]],
      contato2: [contato2 ?? null, [this.whatsappValidator()]],
      contato3: [contato3 ?? null, [this.whatsappValidator()]],
      contato4: [contato4 ?? null, [this.whatsappValidator()]],
      contato5: [contato5 ?? null, [this.whatsappValidator()]],
    });
  }

  showForm() {
    this.buildForm();
    this.isVisible = true;
  }

  create() {
    this.selected = undefined;
    this.showForm();
  }

  update(record: WhatsAppContactDto) {
    this.selected = record;
    this.showForm();
  }

  hideForm() {
    this.isVisible = false;
  }

  submitForm() {
    if (this.form.invalid) return;

    this.isBusy = true;

    const request = this.createRequest().pipe(
      finalize(() => (this.isBusy = false)),
      tap(() => this.confirmationService.success("Dados de contato salvos com sucesso!", "Salvar", this.options)
      ),
    );

    request.subscribe((updated) => this.update(updated));
  }

  changeVisible($event: boolean) {
    this.isVisible = $event;
  }
}
